module.exports = __webpack_public_path__ + "static/media/coreproduct2.782a20d2.png";